<template>
	<div v-show="!showGridpointsOnly" class="gnss-tooltip-overlay" ref="tooltipRoot">
		<template v-if="mapMode === 'coverage'">
			<BaseStationCoverageTooltip
				v-for="item in displayItems"
				:key="item.featureData.id"
				:hovered="item.featureData.id === hoveredId"
				:focused="item.isFocused"
				:mapMode="mapMode"
				:featureData="item.featureData"
				:coords="item.coords"
				:stats="item.stats"
			/>
		</template>
		<template v-else>
			<GnssTooltipMountpoint
				v-for="item in displayItems"
				:key="item.featureData.id"
				:hovered="item.featureData.id === hoveredId"
				:focused="item.isFocused"
				:mapMode="mapMode"
				:allSubnetworksMode="allSubnetworksMode"
				:featureData="item.featureData"
				:coords="item.coords"
				:stats="item.stats"
			/>
		</template>
	</div>
</template>

<script lang="ts">
import { ref, onMounted } from 'vue';
import type { PropType, Ref } from 'vue';
import { useEventListener } from '@vueuse/core';

import GnssTooltipMountpoint from '@/components/map/tooltips/GnssTooltipMountpoint.vue';
import BaseStationCoverageTooltip from '@/components/map/tooltips/BaseStationCoverageTooltip.vue';

import { redirectEventFactory } from '@/utils/useMouseEventRedirector';
import type { GnssTooltipOverlayDisplayItem } from '@/stores/types/mapStoreContracts';
import type { MapMode } from '@/components/map/types/mapFeatureTypes';

export default {
	components: {
		GnssTooltipMountpoint,
		BaseStationCoverageTooltip,
	},
	props: {
		hoveredId: {
			type: Number as PropType<number | null>,
			default: null,
		},
		displayItems: {
			type: Array as PropType<GnssTooltipOverlayDisplayItem[]>,
			required: true,
		},
		mapMode: {
			type: String as PropType<MapMode>,
			required: true,
		},
		showGridpointsOnly: {
			type: Boolean,
			required: true,
		},
		allSubnetworksMode: {
			type: Boolean,
			required: true,
		},
	},
	setup() {
		const tooltipRoot: Ref<HTMLElement | undefined> = ref();
		const redirectEvent = redirectEventFactory('.ol-viewport');
		onMounted(() => {
			useEventListener(tooltipRoot.value, 'pointermove', redirectEvent); // hover
			useEventListener(tooltipRoot.value, 'wheel', redirectEvent); // zoom
			useEventListener(tooltipRoot.value, 'pointerdown', redirectEvent); // click + drag
			useEventListener(tooltipRoot.value, 'touchmove', redirectEvent); // didn't understand
		});
		return {
			tooltipRoot,
		};
	},
}
</script>

<style scoped>
.gnss-tooltip-overlay {
	/* нельзя делать overflow: visible, потому что будет скролл, когда попапы за границей экрана */
	position: absolute;
	inset: 0;
	overflow: hidden;
}
</style>